module.exports = __webpack_public_path__ + "images/fb1e7c349a5839aa49335e15e4a41a3f.svg";